import Cookies from 'js-cookie'
const TokenKey = 'Token-financial'
const Modules = 'MOUDLES'

export function getNewToken () {
  return Cookies.get(TokenKey)
}

export function setNewToken (token) {
  return Cookies.set(TokenKey, token)
}
export function removeNewToken () {
  return Cookies.remove(TokenKey)
}

export function getModules () {
  return Cookies.get(Modules)
}

export function setModules (modules) {
  return Cookies.set(Modules, modules)
}
export function removeModules () {
  return Cookies.remove(Modules)
}



// WEBPACK FOOTER //
// ./src/utils/auth.js